<h5 class="log-cinematic-sub-section-wrapper__header">
    {{ header }}
</h5>
<div class="log-cinematic-sub-section-wrapper__body">
    <ng-content></ng-content>
</div>
